import React, { useEffect } from "react";
import DataTable from "../../components/data-table/data-table.component";
import { Button, Input, Select } from "antd";
import { useNavigate } from "react-router-dom";

const MemberShipPage = () => {
    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState([
        {
            memberName: "Bio staff",
            typesOf: "Basic",
            theway: "Online payments",
            paymentMethod: "Online payments",
            paymentAmount: "Order online - FPS Payment",
            member: "280",//HKD280.00
            orderNum: "2024110133431",
            paymentDate: "-",//-
            createDate: "2024-11-01",
        },
        {
            memberName: "Bio staff",
            typesOf: "Premium",
            theway: "Online payments",
            paymentMethod: "Online payments",
            paymentAmount: "Order online - FPS Payment",
            member: "280",//HKD280.00
            orderNum: "2024110133431",
            paymentDate: "2024-11-10",//-
            createDate: "2024-11-01",
        },
        {
            memberName: "Bio staff",
            typesOf: "Basic",
            theway: "Payment failed	",
            paymentMethod: "Online payments",
            paymentAmount: "Order online - FPS Payment",
            member: "280",//HKD280.00
            orderNum: "2024110133431",
            paymentDate: "2024-11-10",//-
            createDate: "2024-11-01",
        },
        {
            memberName: "Bio staff",
            typesOf: "Premium",
            theway: "Payment cancelled	",
            paymentMethod: "Online payments",
            paymentAmount: "Order online - FPS Payment",
            member: "280",//HKD280.00
            orderNum: "2024110133431",
            paymentDate: "2024-11-10",//-
            createDate: "2024-11-01",
        },
    ]);
    const navigate = useNavigate();

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 5000);
    }, [])

    const tableSettings = {
        appendable: false,
        removable: false,
        bordered: true,
        size: "small",
        pagination: {
          showLessItems: true,
          pageSize: 10,
        },
        columns: [
          {
            title: <span style={{textWrap: "nowrap"}}>Member Name</span>,
            dataIndex: 'memberName',
          },
          {
            title: <span style={{textWrap: "nowrap"}}>Membership Type</span>,
            dataIndex: 'typesOf',
          },
          {
            title: <span style={{textWrap: "nowrap"}}>Amount</span>,
            render: (_, record) => {
                return <>
                 <span className="cursor-pointer"
                  >
                    $200
                  </span>
                </>
              },
          },
          {
            title: <span style={{textWrap: "nowrap"}}>Start date</span>,
            dataIndex: 'createDate',//size
          },
          {
            title: <span style={{textWrap: "nowrap"}}>End date</span>,
            dataIndex: 'createDate',//size
          },
          {
            title: <span style={{textWrap: "nowrap"}}>Action</span>,
            render: (_, record) => {
                return <>
                 <span className="cursor-pointer"
                  //   loading={buttonLoading[record.orderID] || false}
                    onClick={() => {
                        navigate(`/membership/view?${record.memberName}`)
                    }}
                    target="_blank"
                  >
                    View
                  </span>
                </>
              },
          },
        ],
      };

    return (
        <div className="container box-shadow h-100" 
        style={{
            background: "0% 0% no-repeat padding-box padding-box rgb(240, 242, 245)", 
            padding: "32px",
            overflow: "auto"
            }}>

            <div className="w-100">
                <h2 className="text-start">Membership Management</h2>
            </div>

            <div className="w-100">
                <div className="w-100">
                    <div className="d-flex justify-content-between mt-3 mb-3">
                        <div className="d-flex align-items-center">
                            <Input.Search
                                placeholder="Search Membership"
                                size="large"
                                disabled={loading}
                                loading={loading}
                                className="me-2"
                                allowClear
                                style={{ width: '20rem' }}
                            // onChange={(e) => debouncedSearch(e.target.value)}
                            // onSearch={async (value) => await immediateSearch(value, false)}
                            />
                            {/* <Select
                                size={'large'}
                                // value={selectedLocation}
                                style={{ width: 350 }}
                                // onChange={(value) => setSelectedLocation(value)}
                                // options={locationOptions}
                                disabled={loading}
                                loading={loading}
                                placeholder={loading ? 'Fetching Locations' : 'Select Type'}
                            /> */}
                        </div>
                        <div>
                            <Button type="primary" size={'large'}
                                onClick={() => navigate("/membership/view")}
                            >
                                Create Membership
                            </Button>
                        </div>
                    </div>
                </div>

                <div className="w-100">
                    <DataTable
                        loading={loading}
                        data={data}
                        settings={tableSettings}
                    />
                </div>

            </div>
        </div>
    )
}

export default MemberShipPage